import AddressPicker from '@/components/common/addresspicker/AddressPicker.vue'
import BankPicker from '@/components/bank/picker/BankPicker.vue'
import ClientPicker from '@/components/client/picker/ClientPicker.vue'

const defaultBankAccount = {
  id: null,
  accountNumber: '',
  bank: null
};

export default {
  data () {
    return {
      editEl: null,
      loading: false,
      mounted: false
    }
  },
  props: {
    client: Object
  },
  components: {
    ClientPicker,
    AddressPicker,
    BankPicker
  },
  computed: {
    formFields () {
      return {
        name: { type: 'text', disabled: true, class: 'col-sm-12' },
        registryNumber: { type: 'text', disabled: true },
        pvnRegistryNumber: { type: 'text', disabled: true },
        legalAddress: { type: 'address', disabled: true },
        bank_accounts: { type: 'bank_accounts', disabled: true, class: 'col-sm-12' },
        receiptReceiverEmails: { type: 'text', disabled: false },
        primary_filler_user: { type: 'select', disabled: false, options: this.clientUserOptions, label: 'client.primary_filler_user', key: 'api_id', textKey: 'text', required: true },
        postAddress: { type: 'address', disabled: false },
        parent_client_id: { type: 'parentclient', disabled: true }
      };
    },
    clientUserOptions () {
      let options = [];
      if (this.editEl) {
        options = this.BasicHelper.cloneObject(this.editEl.users);
        options.forEach(el => {
          el.text = el.name + ' (' + el.email + ')';
        });
      }
      return options;
    }
  },
  methods: {
    save () {
      if (!this.loading) {
        this.loading = true;
        const reqData = { client: {}, bank_account: [] };
        for (const key of Object.keys(this.formFields)) {
          if (!this.formFields[key].disabled) {
            reqData.client[key] = this.editEl[key];
          }
        }
        const self = this;
        this.ApiRequest.request('client/single/' + this.editEl.api_id, this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            const clientPerm = self.$session.get('client_permissions');
            if (clientPerm) {
              clientPerm[self.editEl.api_id].needUpdate = false;
            }
            self.$session.set('client_permissions', clientPerm);
            self.$router.go(self.$router.currentRoute)
          }
          self.loading = false;
        });
      }
    }
  },
  mounted () {
    this.editEl = this.BasicHelper.cloneObject(this.client);
    const self = this;
    let fillUser = this.editEl.users.find(el => el.id === self.client.primary_filler_user_id);
    if (!fillUser) {
      fillUser = this.editEl.users.find(el => el.api_id === self.$session.get('uuid'));
    }
    if (fillUser) {
      this.editEl.primary_filler_user = fillUser.api_id
    } else {
      this.editEl.primary_filler_user = (this.clientUserOptions.length > 0 ? this.clientUserOptions[0].api_id : null);
    }
    if (this.editEl.bank_accounts.length === 0) {
      this.editEl.bank_accounts.push(this.BasicHelper.cloneObject(defaultBankAccount));
    }
    this.mounted = true;
    this.ApiRequest.displaySuccessDialog(this, this.$t('menu.clients.simple-edit.message'), this.$t('general.warning'));
  }
}
